const Option = ({ text }) => {
  return <option>{text}</option>;
};

export default Option;
